import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import clsx from 'clsx';
import { chainPropTypes } from '@material-ui/utils';
import { capitalize } from '@material-ui/core/utils';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var styles = function styles() {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `pending={true}`. */
    pending: {},

    /* Styles applied to the pendingIndicator element. */
    pendingIndicator: {
      position: 'absolute',
      visibility: 'visible',
      display: 'flex'
    },

    /* Styles applied to the pendingIndicator element if `pendingPosition="center"`. */
    pendingIndicatorCenter: {
      left: '50%',
      transform: 'translate(-50%)'
    },

    /* Styles applied to the pendingIndicator element if `pendingPosition="start"`. */
    pendingIndicatorStart: {
      left: 14
    },

    /* Styles applied to the pendingIndicator element if `pendingPosition="end"`. */
    pendingIndicatorEnd: {
      right: 14
    },

    /* Styles applied to the endIcon element if `pending={true}` and `pendingPosition="end"`. */
    endIconPendingEnd: {
      visibility: 'hidden'
    },

    /* Styles applied to the startIcon element if `pending={true}` and `pendingPosition="start"`. */
    startIconPendingStart: {
      visibility: 'hidden'
    },

    /* Styles applied to the label element if `pending={true}` and `pendingPosition="center"`. */
    labelPendingCenter: {
      visibility: 'hidden'
    }
  };
};

var PendingIndicator = /*#__PURE__*/_jsx(CircularProgress, {
  color: "inherit",
  size: 16
});

var LoadingButton = /*#__PURE__*/React.forwardRef(function LoadingButton(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$pending = props.pending,
      pending = _props$pending === void 0 ? false : _props$pending,
      _props$pendingIndicat = props.pendingIndicator,
      pendingIndicator = _props$pendingIndicat === void 0 ? PendingIndicator : _props$pendingIndicat,
      _props$pendingPositio = props.pendingPosition,
      pendingPosition = _props$pendingPositio === void 0 ? 'center' : _props$pendingPositio,
      other = _objectWithoutPropertiesLoose(props, ["children", "classes", "className", "disabled", "pending", "pendingIndicator", "pendingPosition"]);

  return /*#__PURE__*/_jsxs(Button, _extends({
    className: clsx(classes.root, className, pending && classes.pending),
    disabled: disabled || pending,
    ref: ref,
    classes: {
      startIcon: classes["startIcon".concat(pending ? 'Pending' : '').concat(capitalize(pendingPosition))],
      endIcon: classes["endIcon".concat(pending ? 'Pending' : '').concat(capitalize(pendingPosition))],
      label: classes["label".concat(pending ? 'Pending' : '').concat(capitalize(pendingPosition))]
    }
  }, other, {
    children: [pending && /*#__PURE__*/_jsx("div", {
      className: clsx(classes.pendingIndicator, classes["pendingIndicator".concat(capitalize(pendingPosition))]),
      children: pendingIndicator
    }), children]
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default withStyles(styles, {
  name: 'MuiLoadingButton'
})(LoadingButton);